module.exports = __webpack_public_path__ + "static/media/cacao-boat-carry.4c19546f.jpg";